class HHProductMediaCarousel extends HTMLElement {
  constructor() {
    super()

    this.product_id = this.dataset.productId
    this.suffix = this.dataset.suffix
    this.slider = this.querySelector('.js-product-media-slider')
    this._doSlider = this._doSlider.bind(this)
    this._updateDots = this._updateDots.bind(this)
  }

  connectedCallback() {
    this.$slider = $(this.slider)
    this._attachListeners()
    this._doSlider()
  }

  _doSlider() {
    if (!this.$slider.hasClass('slick-initialized')) {
    if (this.suffix !== 'simple') {
      var redesign = this.suffix === 'figma-redesign-new'
      this.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'slick-dots slick-thumb grid-container',
        responsive: [
          {
            breakpoint: 768,
            // Redesign template: one full-width image per slide with simple dot indicators.
            // Other templates keep the original peeking (variableWidth) gallery with no dots.
            settings: redesign
              ? { variableWidth: false, dots: true, arrows: false }
              : { variableWidth: true, dots: true }
          }
        ]
      })
      const _this = this
      this.$slider.on('breakpoint', function (event, slick, breakpoint) {
        if (!breakpoint) {
          _this._updateDots()
        }
      })

      // Only build the thumbnail-style dots on desktop; on mobile the dots stay as plain indicators.
      if (window.matchMedia('(min-width: 768px)').matches) {
        this._updateDots()
      }

      // Redesign: flag the slider when the side thumbnail column overflows (more than
      // 3 thumbs) so a down-arrow scroll cue can show. Re-checks on resize.
      if (redesign) {
        const flagThumbs = () => {
          const dots = this.querySelector('.slick-dots')
          const slider = this.querySelector('.slick-slider') || this.slider
          if (dots && slider) {
            slider.classList.toggle('has-more-thumbs', dots.scrollHeight - dots.clientHeight > 4)
          }
        }
        setTimeout(flagThumbs, 60)
        window.addEventListener('resize', flagThumbs)
      }

      // Mobile: tap anywhere on the image to go to the next slide (wraps back to the first
      // at the end, via slick's infinite mode). A real swipe already changes the slide on
      // its own, so we must ONLY advance on a genuine tap. Relying on the `click` event
      // alone is unreliable on touch — a tap often carries a few px of movement and the
      // synthesized click may never fire (and slick can swallow it). So we detect taps from
      // the touch events directly (negligible movement = tap) and keep a `click` fallback
      // for non-touch/dev pointers, guarded so a touch doesn't advance twice. Bound to
      // .slick-list (the image viewport) so the dots, which live outside it, keep their own
      // "go to this slide" behaviour.
      if (redesign) {
        const list = this.querySelector('.slick-list')
        if (list) {
          const isMobile = () => window.matchMedia('(max-width: 767px)').matches
          const advance = () => {
            if (isMobile() && this.$slider.hasClass('slick-initialized')) {
              this.$slider.slick('slickNext')
            }
          }
          let startX = 0, startY = 0, moved = false, recentTouch = false
          list.addEventListener('touchstart', (e) => {
            const t = e.changedTouches[0]
            startX = t.clientX; startY = t.clientY; moved = false
            recentTouch = true
          }, { passive: true })
          list.addEventListener('touchmove', (e) => {
            const t = e.changedTouches[0]
            if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) moved = true
          }, { passive: true })
          list.addEventListener('touchend', () => {
            if (!moved) advance()                 // no real movement → it's a tap
            // Ignore the synthetic click that follows this touch so we don't advance twice.
            setTimeout(() => { recentTouch = false }, 500)
          }, { passive: true })
          list.addEventListener('click', () => {
            if (recentTouch) return               // already handled by touchend
            advance()
          })
        }
      }


      if(this.suffix === 'pdp-redesign-v2' || this.suffix === 'figma-redesign-new') {
        this.$slider.on('click', '.slick-slide', () => {
          this.$slider.slick('slickNext');
        });
      }

      // The figma redesign stylesheet is loaded async and turns the mobile
      // gallery full-bleed (100vw) AFTER slick has already measured the
      // narrower grid-column width. Recalculate the slide/track widths
      // whenever the carousel's own width actually changes so the active
      // image fills the screen.
      if (redesign && 'ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
          if (this.$slider.hasClass('slick-initialized')) {
            this.$slider.slick('setPosition')
          }
        })
        ro.observe(this)
      }
    } else {
      this.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        variableWidth: true
      })
    }
  }
  }
  _updateDots() {
    const slides = Array.from(
      this.querySelectorAll('.slick-track .slick-slide:not(.slick-cloned)')
    )
    const dots = Array.from(this.querySelectorAll('.slick-dots li'))
    let element = null
    for (let index = 0; index < dots.length; index++) {
      element = document.createElement('span')
      element.className =
        'product-image-wrapper product-image-wrapper-constrained product-thumb'
      element.innerHTML =
        slides[index].querySelector('.product-slide').innerHTML
      dots[index].querySelector('button').appendChild(element)
    }
  }

  changeMedia(data) {
    let selectedColor = data.variant_details.option1;
    let allMedia = data.other_media;
    let matchingMediaHtml = '';
    var allVariantText = '';
    var storedIds = [];
    // before we start to limit things, we need to make sure it's a color before limiting the options by color
    if ($('.bundle-item-hero__active').length > 0) {
          $('.bundle-item-hero__active').find('.js-swatch__group-label').each(function() {
      var text = $(this).text().trim();
      allVariantText += text + ',';
    });
    if ($('.bundle-item-hero__active').find('.swatch__group--color').length > 0) {
        allVariantText += 'color,';
    } 
  }
  else {
    $('.js-swatch__group-label').each(function() {
      var text = $(this).text().trim();
      allVariantText += text + ',';
    });
    if ($('.swatch__group--color').length > 0) {
      allVariantText += 'color,';
  } 
  }
  if (allVariantText.indexOf('Color') > -1 || allVariantText.indexOf('color') > -1) {
    allMedia.find('.true-img[alt="'+selectedColor+'"]').each(function() {
      let media = $(this); // Wrap the current element with jQuery
      matchingMediaHtml += media.parent().parent().parent().parent().prop('outerHTML');  
  });
}
else {

// Use jQuery's .each() to iterate over the jQuery object
allMedia.find('.true-img').each(function() {
  let media = $(this); // Wrap the current element with jQuery
  let media_id = media.attr('data-media-id') || 'blank';
  let altText = media.attr('alt'); // Get the 'alt' attribute
    // since we have multiple of the same images potentially with no colors, we need to dedupe
    if (storedIds.includes(media_id) && media_id != 'blank') {
    }
    else {
    matchingMediaHtml += media.parent().parent().parent().parent().prop('outerHTML');
    storedIds.push(media_id);
    }
});
}
    var sliderContainer = data.this_slider; // The direct container initialized with Slick
    sliderContainer = $(sliderContainer);
    if (sliderContainer) {
        // Destroy existing Slick instance if present
        
        if ($(sliderContainer).hasClass('slick-initialized')) {
            $(sliderContainer).slick('unslick');
        }

        // Clear and repopulate the container
        sliderContainer.html(matchingMediaHtml);
        // Delay reinitialization to ensure the DOM has updated
            this._doSlider(); // Adjust this method as necessary
    }
  if (data.is_bundle == true) {
    // we need to also update the very first slider under main product panel in case this is desktop
    var bundleSlideContainer = $('.js-product-media-slider').eq(0);
    if (bundleSlideContainer) {
      // Destroy existing Slick instance if present
      
      if ($(bundleSlideContainer).hasClass('slick-initialized')) {
          $(bundleSlideContainer).slick('unslick');
      }
      // Clear and repopulate the container
      bundleSlideContainer.html(matchingMediaHtml);
      
      bundleSlideContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'slick-dots slick-thumb grid-container',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: true,
              dots: false
            }
          }
        ]
      });
// Enhance each dot with a product image, ensuring dots are scoped within bundleSlider
$(bundleSlideContainer).find('.slick-dots li').each(function(index) {
  var $dot = $(this);
  // Ensure we're getting the slides from within the context of bundleSlideContainer
  var $slide = $(bundleSlideContainer).find('.slick-track .slick-slide:not(.slick-cloned)').eq(index);
  var $element = $('<span></span>', {
      class: 'product-image-wrapper product-image-wrapper-constrained product-thumb',
      html: $slide.find('.product-slide').html()
  });
  $dot.find('button').append($element);
});
  }
  }
  }

  _attachListeners() {
    document.addEventListener('product-media::change', (event) => {
      if (this.product_id === event.detail.product_id) {
        this.changeMedia(event.detail)
      }
      if (event.detail.product_id !== event.detail.parent_id && this.product_id === event.detail.parent_id) {
        this.changeMedia(event.detail)
      }
    });
   
  }
}

customElements.define('hh-product-media-carousel', HHProductMediaCarousel)
